import React from 'react';
import PropTypes from 'prop-types';

import {
    TextButton,
    Text,
    Button,
    Input,
    Spacer,
    Label,
    Flex,
} from '@zillow/constellation';

import {
    StyledMDActionsContainer,
    StyledMDContainer,
    StyledMDContent,
    StyledMDContentContainer,
} from 'app/shared/containers/ModalContainer/StyledComponents';

const propTypes = {
    onSubmit: PropTypes.func,
    onClose: PropTypes.func.isRequired,
    targetEmail: PropTypes.string.isRequired,
    userName: PropTypes.string.isRequired,
};

const defaultProps = {
    onSubmit: () => { },
};

const ResendCompanyInviteModal = ({
    onSubmit,
    onClose,
    targetEmail,
    userName,
}) => {
    const [email, setEmail] = React.useState('');

    return (
        <StyledMDContainer>
            <StyledMDContentContainer>
                <StyledMDContent>
                    <Text as="div">{`Please confirm ${userName}'s email address.`}</Text>
                    <Spacer marginTop="xs">
                        <Label>Email:</Label>
                    </Spacer>
                    <Input
                        value={email}
                        onChange={e => setEmail(e.target.value.trim())}
                    />
                </StyledMDContent>
            </StyledMDContentContainer>
            <StyledMDActionsContainer>
                <Spacer marginTop="xs">
                    <Flex display="flex" justifyContent="flex-end" alignItems="center">
                        <Spacer marginRight="xs">
                            <TextButton onClick={onClose}>Cancel</TextButton>
                        </Spacer>
                        <Button
                            onClick={onSubmit}
                            buttonType="primary"
                            disabled={email !== targetEmail}
                        >
                            Resend Invite
                        </Button>
                    </Flex>
                </Spacer>
            </StyledMDActionsContainer>
        </StyledMDContainer>
    );
};

ResendCompanyInviteModal.propTypes = propTypes;
ResendCompanyInviteModal.defaultProps = defaultProps;

export { ResendCompanyInviteModal };
export default ResendCompanyInviteModal;
